//This templeates initial purpose was to serve as a place to quickly copy and pase
//a style function file that follows this projects design pattern

import React, {useContext} from 'react';
import {GlobalContext} from '../../utilities/GlobalContext';

function Styles() {
	//#region Params
	let isMobile = useContext(GlobalContext).isMobile;
	let size = useContext(GlobalContext).size;
	let minimumMarginX = useContext(GlobalContext).minimumMargin;
	//#endregion

	//#region Style vars
	let titleFontSize = '4rem';
	//#endregion

	//#region seting vars based off params
	if (size === 'lg') {
	} else if (size === 'md') {
	} else if (size === 'sm') {
	}
	if (isMobile) {
		titleFontSize = '3rem';
	}
	//#endregion

	return {
		outerStyle: ({mt} = {}) => {
			return {
				display: 'flex',
				flexDirection: 'column',
				backgroundColor: '#262626',
				overflow: 'hidden',
				position: 'relative',
				paddingBottom: '3rem',
				marginTop: mt ? `3rem` : `unset`,
			};
		},
		innerContentContainer: () => {
			return {
				padding: `0 ${minimumMarginX}rem`,
				zIndex: 1,
			};
		},
		titleStyle: () => {
			return {
				textAlign: 'center',
				zIndex: 10,
				position: `relative`,
				marginTop: '3rem',
				fontSize: titleFontSize,
			};
		},
		imageStyle: ({isBottom}) => {
			return {
				width: `100%`,
				position: 'absolute',
				bottom: isBottom ? 0 : 'unset',
			};
		},
		genericTextStyle: () => {
			return {
				marginTop: '1rem',
				color: 'white',
			};
		},
		subtitleTextStyle: () => {
			return {
				marginTop: '1rem',
				fontSize: titleFontSize,
			};
		},
	};
}

export default Styles;
